import ProgressBar from '@/components/atoms/progress-bar/progress-bar';
import IStudentSuccess from '@/models/viewModels/IStudentSuccess';
import React from 'react';
import styles from './student-success.module.scss';

type Props = {
  metrics: IStudentSuccess[];
};

export default function StudentSuccess({ metrics = [] }: Props) {
  return (
    <div id="student-success" className={`${styles.student_success} rounded-border-6`}>
      {metrics.map((metric) => (
        <div className="mb-3" key={metric.name}>
          <ProgressBar
            key={metric.name}
            heading={metric.name}
            value={+metric.value}
            barColor={metric.barColor}
          />
        </div>
      ))}
    </div>
  );
}
